exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-fec1d9a6] {\n  display: block;\n  width: 6.5rem;\n  margin: auto;\n  margin-top: 3.67rem;\n  margin-bottom: 0.53rem;\n}\np[data-v-fec1d9a6] {\n  font-size: 0.5rem;\n  color: #c5c5c5;\n  text-align: center;\n  margin-top: 1rem;\n}\n", ""]);

// exports
